<template>
	<div class="upload-file-wrapper" style="text-align:center;">
		<!-- <el-upload action="" :http-request="upload"  :accept="accepttypes"  multiple :on-remove="handleRemove" :before-upload="beforeAvatarUpload" :file-list="fileList" >
            <el-button size="small" type="primary">选择文件</el-button>
        </el-upload> -->
		<a href="javascript:;" class="file">{{buttonnamestr}}
			<input type="file" @change="filechange" :accept="acceptType" multiple="multiple" ref="files" v-if="ifmultiple"/>
			<input type="file" @change="filechange" :accept="acceptType" ref="files" v-if="!ifmultiple"/>
		</a>
		<div v-if="showTips" style="font-size:12px;    line-height: 20px;">{{tipText}}</div>

		<div class="error-hint" v-if="error.has">{{error.msg}}</div>

	</div>
</template>

<script>
	export default {
		props: {
            disabled: Boolean,
            showTips: {
                type: Boolean,
                default: true
            },
            tipText: {
                type: String,
                default: '仅支持jpg、jpeg格式，建议尺寸640*480，大小不超过200k'
            },
            maxSizeMsg: {
                type: String,
                default: ''
            },
			upload: Function,
			filename: {
				type: String,
				default: null
			},
			buttonname: {
				type: String,
				default: null
			},
			acceptType: {
				type: String,
				default: '.txt,.pdf,.docx,.doc,.xls,.ppt,.jpg,.jpeg,.png,gif,.bmp,.3GP,.avi,.flv,.mp4,.asf,.wmv,.mkv,.mov,.ts,.mxf,.webm'
			},
			maxFileSize: {
				type: Number,
				default: 300000000
			},
			ifmultiple:{
				type: Boolean,
				default: false
			},

		},
		
		data() {
			return {
				buttonnamestr:this.buttonname,
				accepttypes: this.acceptType,
				maxFileSizes: this.maxFileSize,
				Progress: 0,
				progressShow: false,
				fileList: [],
				error: {
					has: false,
					msg: ''
				},
				messages: {
					acceptFileTypes: '不允许的文件类型',
					maxFileSize: '文件太大',
					minFileSize: '文件太小',
					document: '限.doc/.docx/.xls/.xlsx/.txt/.pdf/.rar/.zip格式的文件',
					all: '限.doc/.docx/.xls/.xlsx/.txt/.pdf/.rar/.zip格式的文件',
					image: '限jpg,pgn,gif格式的图片',
					audio: '限mp3、m4a、wma格式的音频',
					video: '限.mp4/格式的视频',
					pdf: '限.pdf格式的文件'
				},
			}
		},
		watch: {
			 buttonname(val, oldVal) {
			console.log(val);
            this.buttonnamestr=val;
        },
			filename(val) {
				if(val && val !== '') {
					this.fileList = [{
						name: val
					}]
				} else {
					this.fileList = [];
				}
			},
			acceptType(val, oldval) {
				if(val !== '' && val !== oldval) {
					this.clear();
				}
			}
		},
		mounted() {
			if(this.filename && this.filename !== '') {
				this.fileList = [{
					name: this.filename
				}]
			} else {
				this.fileList = [];
			}
		},
		methods: {
			filechange() {
				
				let files = this.$refs.files.files;			
				if(files.length>0){
				let newfilesarray = [];
				for(let index = 0; index < files.length; index++) {
					let element = files[index];				
					if(element.size > this.maxFileSizes) {
						this.$message(this.maxSizeMsg || '文件过大,请重新上传');
                        return false;
					} else {
						newfilesarray.push(element);
					}
				};
				this.$emit('upload', newfilesarray);
			}
			}

		}
	}
</script>

<style type="text/css" lang="scss" rel="stylesheet/scss">
	.upload-file-wrapper {
		text-align: left;
		.error-hint {
			font-size: 12px;
			line-height: 1.8;
			padding: 4px 5px 3px;
			color: #ff4949;
		}
		.el-upload__tip {
			display: inline-block;
			margin-left: 10px;
		}
	}

	.file {
		position: relative;
		display: inline-block;
		background: #26AFF5;
		border: 1px solid #dcdfe6;
		border-radius: 4px;
		padding: 4px 12px;
		overflow: hidden;
		color: #fff;
		text-decoration: none;
		text-indent: 0;
		line-height: 20px;
		padding: 10px 20px;
		font-size: 14px;
		input {
			position: absolute;
			font-size: 100px;
			right: 0;
            top: 0;
            left: 0;
            bottom: 0;
			opacity: 0;
			width: 100%;
			height: 100%;
		}
	}

	.file:hover {
		background: #ECF5FF;
		border-color: #C6E2FF;
		color: #409EFF;
		text-decoration: none;
	}
</style>


// WEBPACK FOOTER //
// src/components/upload_img/uploadfile.vue